import { HOOK_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/hooks';
import type { HookFilterableField } from '@kirin/api-client/contracts/hooks';

export const HOOK_TABLE_CONFIG = {
  tableId: 'org-hooks',
} as const;

/**
 * Cache lifetime for hook-tab queries (list, detail content, group projects).
 * Single source so the three call sites stay in lockstep.
 */
export const HOOK_STALE_TIME_MS = 30_000;

/**
 * Short URL keys for each filterable hook field (URL state persistence).
 * `name`/`sourceType` have no column in the tab but are kept here so the
 * record satisfies the full field set.
 */
export const HOOK_FILTER_URL_KEYS = {
  [HOOK_FILTERABLE_FIELDS.NAME]: 'hn',
  [HOOK_FILTERABLE_FIELDS.FILE_CATEGORY]: 'hc',
  [HOOK_FILTERABLE_FIELDS.FAMILY]: 'hfa',
  [HOOK_FILTERABLE_FIELDS.PLATFORM]: 'hp',
  [HOOK_FILTERABLE_FIELDS.SOURCE_TYPE]: 'hst',
  [HOOK_FILTERABLE_FIELDS.FILE]: 'hfi',
  [HOOK_FILTERABLE_FIELDS.SUMMARY]: 'hs',
  [HOOK_FILTERABLE_FIELDS.PROJECTS]: 'hpr',
} as const satisfies Record<HookFilterableField, string>;

/**
 * Lightweight chip color classes per hook source family, mirroring the
 * AI Instructions "type" badge palette so the inventory feels coherent.
 */
export const FAMILY_BADGE_CLASSES: Record<string, string> = {
  'coding-agent': 'bg-purple-100 text-purple-700 border-purple-200',
  git: 'bg-orange-100 text-orange-700 border-orange-200',
};
